<template>
  <div class="editBG pt-0 mt-5 mx-0" style="min-height: 100%; margin: 0 auto">
    <v-snackbar
      v-model="snackbar"
      auto-height
      :color="snackbarColor"
      right
      top
      :timeout="timeout"
      vertical
      >{{ humanize(this.snackbarFieldName) }}</v-snackbar
    >

    <v-navigation-drawer
      width="320"
      temporary
      absolute
      fixed
      right
      dark
      style="position: fixed; top: 0px"
      class="px-2 navbar"
      hide-overlay
      v-model="options_c"
    >
      <!-- TITLE -->
      <v-layout row pt-3 pl-2 pb-2>
        <v-flex>
          <v-subheader
            class="font-weight-regular display-1 white--text pl-0 ml-0"
          >
            <!-- Options -->
            <v-spacer></v-spacer>
            <!-- <a @click="options_c=false" class="font-weight-regular display-1 white--text"> X</a> -->
            <v-btn @click="options_c = false" icon v-if="options_c">
              <v-icon color="white" x-large>chevron_right</v-icon>
            </v-btn>

            <!-- <v-btn small flat @click="clearFilters()">X</v-btn> -->
          </v-subheader>
        </v-flex>
      </v-layout>

      <v-divider class="mx-3 pb-0 mb-0 white"></v-divider>

      <!-- EDITING ARTWORK -->
      <!-- <v-layout row pt-0 mt-0>
        <v-flex >
          <v-subheader class="white--text">
      Editing Artwork-->
      <!-- <v-spacer></v-spacer> -->
      <!-- <a @click="clear_selection" v-if="this.selected.length>0">Clear Selection</a> -->
      <!-- <a @click="options_c=false" class="font-weight-regular display-1 white--text"> X</a> -->

      <!-- </v-subheader>
        </v-flex>
      </v-layout>-->

      <v-list>
        <!-- <v-list-tile class="pl-0 ml-4 white--text" @click="$router.push({ path: child.path })">
          <v-list-tile-content>
            <v-list-tile-title> <a class="white--text" @click="">Select all Artworks</a> </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="pl-0 ml-4" @click="$router.push({ path: child.path })">
          <v-list-tile-content>
            <v-list-tile-title> Change Selected Artworks </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>-->

        <!-- <v-list-group style="height:200px; overflow: scroll;"> -->
        <v-list-tile
          value="true"
          v-for="tab in user_tabs"
          :key="tab.key"
          @click="setCurrentTab(tab['key'])"
          v-model="tab.active"
          avatar
          :class="{
            activeMenu: tab.key == currentTab,
            'pl-0 ml-4 my-2 mr-4': true,
          }"
          active-class="default-class activeMenu"
        >
          <v-list-tile-avatar>
            <v-icon>{{ tab.icon }}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ tab.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <!-- <v-list-tile
          class="pl-0 ml-4"
          key="zip"
          @click="`http://www.tb-cms.org/zip/${artworkFormData.id}`"
        >
          <v-list-tile-content>
            <v-list-tile-title>
              <a :href="`http://www.tb-cms.org/zip/${artworkFormData.id}`"
                >Download ZIP</a
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile> -->

        <!-- </v-list-group> -->
      </v-list>
      <!--
      <v-divider class="mx-3 pb-0 mb-0 white"></v-divider>
      <v-layout row pt-0 mt-0 v-if="c_user.roles.find(ur => ur.shortcut == 'file_d')">
        <v-flex >
          <v-subheader class="white--text">
            Export PDF for:
            <v-spacer></v-spacer>
            <a @click="">Export</a>
          </v-subheader>
        </v-flex>
      </v-layout>-->

      <!-- <v-list>

        <v-list-tile class="pl-0 ml-4" @click="setCurrentTab(tab['key'])">
          <v-list-tile-content>
            <v-list-tile-title>Artwork Details </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="pl-0 ml-4" @click="setCurrentTab(tab['key'])">
          <v-list-tile-content>
            <v-list-tile-title>Texts  </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="pl-0 ml-4" @click="setCurrentTab(tab['key'])">
          <v-list-tile-content>
            <v-list-tile-title>Loan History </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="pl-0 ml-4" @click="setCurrentTab(tab['key'])">
          <v-list-tile-content>
            <v-list-tile-title>Exhibition History </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

      </v-list>-->
    </v-navigation-drawer>

    <v-layout
      row
      wrap
      style="
        background-color: white;
        height: 300px;
        width: 100%;
        top: 120px;
        position: fixed;
        z-index: 1;
        height: 50px;
      "
    >
      <v-flex xs12> </v-flex>
    </v-layout>

    <!-- <v-toolbar tabs color="white elevation-1" style="top:67px; position:fixed; z-index: 5;"> -->
    <!-- padding-top: 30px; position:fixed;  -->
    <!-- border-bottom: solid black 1px; -->
    <v-layout
      mx-0
      px-3
      ml-0
      mt-0
      pt-0
      pb-3
      style="
        z-index: 1;
        top: 135px;
        position: sticky;
        width: 100%;
        border-bottom: 1px solid #999;
        background-color: #fff;
      "
    >
      <v-flex class="xs8 pl-4 ml-1 mr-0">
        <v-flex class="xs12 pb-0 mb-0">
          <h4
            class="headline font-weight-bold pt-2 pb-1 my-0"
            v-if="artworkFormData.artist"
          >
            <router-link
              :to="'/artists/edit/' + artworkFormData.artist_id"
              class="my-0 py-0"
              >{{ artworkFormData.artist.name }}</router-link
            >
          </h4>
          <h4 v-else>{{ artworkFormData.artist_name }}</h4>
        </v-flex>
        <v-flex class="xs12">
          <h4 class="headline py-0 my-0 font-weight-light">
            <span
              :class="{ 'red--text': artworkFormData.deaccessioned }"
              v-html="
                `${artworkFormData.title}, ${artworkFormData.production_date_new}`
              "
            ></span>
            <v-tooltip top v-if="hasArtworkSeries(artworkFormData)">
              <v-icon
                slot="activator"
                small
                class="series-indicator ml-2"
              >collections_bookmark</v-icon>
              <span>{{ artworkSeriesLabel(artworkFormData) }}</span>
            </v-tooltip>
            <v-tooltip top v-if="hasCurrentExhibitions(artworkFormData)">
              <v-icon
                slot="activator"
                small
                class="on-view-indicator ml-2"
              >visibility</v-icon>
              <span>{{ currentExhibitionsLabel(artworkFormData) }}</span>
            </v-tooltip>
          </h4>
          <h4
            class="headline py-0 my-0 font-weight-light"
            v-if="artworkFormData.subtitle"
          >
            <span
              :class="{ 'red--text': artworkFormData.deaccessioned }"
              v-html="artworkFormData.subtitle"
            ></span>
          </h4>
          <!-- </v-flex>
          <v-flex class="xs12">-->
          <h4 class="title py-0 mt-2 font-weight-light">
            <span class v-html="`${artworkFormData.accession_number}`"></span>
          </h4>
        </v-flex>
      </v-flex>
      <!-- <v-spacer></v-spacer> -->
      <v-layout class="xs4 my-0 pr-3 pt-1 justify-end column">
        <!-- CLOSE BUTTON -->
        <v-flex class="xs12 pr-0 mb-0 text-xs-right">
          <!-- <v-btn-toggle
            v-model="gemini_check"
            class="mr-5 light"
            light
            v-if="[12, 15, 16].includes(artworkFormData.ownership)"
            @change="toggleGemini(gemini_check)"
          >
            <v-btn
              small
              class="px-2"
              color="success"
              light
              input-value="1"
              :value="1"
              >YES</v-btn
            >
            <v-btn
              small
              class="px-2"
              color="error"
              light
              input-value="0"
              :value="0"
              >NO</v-btn
            >
          </v-btn-toggle> -->
          <v-btn
            @click="
              options = false
              $router.go(-1)
            "
            icon
            class="mx-0 mt-0"
            style="height: 30px !important"
          >
            <v-icon color="black">close</v-icon>
          </v-btn>
        </v-flex>
        <!-- <v-btn @click="options_c=false;" icon v-if="options_c"><v-icon color="black" x-large>chevron_right</v-icon></v-btn> -->
        <v-flex
          class="
            headline
            text-uppercase
            grey--text
            text--darken-3
            font-weight-thin
            text-xs-right
          "
        >
          <v-btn
            @click="goToPreviousTab()"
            icon
            class="mr-2 px-0 mt-0 py-0"
            v-if="hasPreviousTab"
            style="height: 36px"
          >
            <v-icon color="black">chevron_left</v-icon>
          </v-btn>

          <a @click="options_c = true" class="tabswitcher">
            <span>{{ currentTab }}</span>
          </a>

          <v-btn
            @click="goToNextTab()"
            icon
            class="ml-3 px-0 mr-0 mt-0 py-0"
            v-if="hasNextTab"
            style="height: 36px"
          >
            <v-icon color="black">chevron_right</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <!-- <a class="headline mr-3 pr-3 black--text" @click="options=false;$router.go(-1)">close</a> -->
    </v-layout>

    <!-- <v-menu bottom right>
        <v-btn slot="activator" icon>
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click="addToSelection(artworkFormData.id)">
            <v-list-tile-title>Add this artwork to list</v-list-tile-title>
          </v-list-tile>
          <pdf-eh :artwork="artworkFormData"></pdf-eh>
        </v-list>
    </v-menu>-->
    <!-- <v-btn icon><v-icon>more_vert</v-icon></v-btn> -->
    <!-- <v-tabs slot="extension" color="transparent" slider-color="purple" align-with-title v-model="currentTab" show-arrows> -->
    <!-- <v-tab v-for="tab in fields.tabs" :ripple="false"
          :key="tab.key"
          :href="'#tab-' + tab.key"
          @click="saveCurrentTab('tab-' + tab.key)"
          v-if="tab.work_types && tab.work_types.includes(artworkFormData.classification)"
        >
    {{ tab.title }}-->
    <!-- </v-tab> -->
    <!-- </v-tabs> -->
    <!-- </v-toolbar> -->
    <!-- {{this.fields.tabs}} -->

    <v-flex
      v-for="tab in fields.tabs"
      :key="tab.key"
      :id="'tab-' + tab.key"
      class="grey lighten-3 elevation-0 ml-0 pl-0"
      style="position: relative; top: 20px"
    >
      <div v-if="tab.key == currentTab">
        <v-card
          class="editBG mx-0 mt-0 xs12 sm6 elevation-0"
          v-if="
            tab.component &&
            c_user &&
            c_user.roles &&
            c_user.roles.find((f) => f.shortcut == tab.role)
          "
        >
          <v-container grid-list-xs fluid class="xs12 sm6">
            <v-layout row wrap class="xs12">
              <component
                class="xs12 mx-0 px-0"
                style="width: 100%"
                :film="film"
                @showSnackbar="showSnackbar"
                :is="tab.component"
                @getArtwork="getArtwork"
                :artwork="artworkFormData"
              >
                <!-- component changes when vm.currentView changes! -->
              </component>
            </v-layout>
          </v-container>
        </v-card>

        <v-card class="grey lighten-3 ml-0 pl-0 pr-0 pt-0 elevation-0" v-else>
          <!-- v-btn @click="show('background_of_origin')">show</v-btn> -->
          <v-container grid-list-xs fluid pt-0 px-4>
            <v-layout row wrap px-2>
              <v-flex sm12 md6 order-sm2 order-md1>
                <!-- <v-flex v-if="currentTab!='basic'">
                      <edit-field v-for="field in currentFields" v-show="df2.indexOf(field['name'])==-1" :id="field.name" :name="field.name"
                        :class="'flex ' + (field.class ? field.class : 'xs12') + (field.dynamic ? ' red lighten-5' : '')" :artwork="processedArtwork"
                        :field="field"
                        :key="field.name"
                        :film="film"
                        @show='show'
                      >
                      </edit-field>
                  </v-flex>
                <v-flex v-else>-->
                <!-- <v-flex xs12> -->
                <v-layout row wrap>
                  <v-flex
                    v-for="field in currentFields"
                    :class="'flex ' + (field.class ? field.class : 'xs12')"
                    :key="field.name"
                  >
                    <!-- {{df2['background_of_origin']}} -->
                    <!-- <view-field v-for="field in field_list" v-show="df2.indexOf(field['name'])==-1" :id="field.name" :name="field.name"
                            :class="'flex ' + (field.class ? field.class : 'xs12') + (field.dynamic ? ' red lighten-5' : '')" :artwork="processedArtwork"
                            :field="field"
                            :key="field.name"
                            :film="film"
                            @show='show'
                          >
                    </view-field>-->

                    <!-- v-if="
                        (c_user.edit &&
                          ([
                            'deaccession_date',
                            'comment_on_deaccession',
                            'new_ownership',
                            'deaccession_price_offer',
                            'deaccession_price_paid',
                            'invoice_deaccession_papers'
                          ].includes(field.name)
                            ? artworkFormData.deaccessioned == 1
                            : true)) ||
                          (field.name == 'fvs_subtitle' &&
                            (artworkFormData.type_of_work_id == 7 ||
                              (artworkFormData.type_of_work_id == 6 &&
                                artworkFormData.including_film == 1)))
                      " -->
                    <!-- 1{{ artworkFormData[field.condition_field] }}2
                    {{ field.condition_value }}3 -->
                    <edit-field
                      v-show="df2.indexOf(field['name']) == -1"
                      :id="field.name"
                      :name="field.name"
                      v-if="
                        c_user.edit &&
                        artworkFormData[field.condition_field] ==
                          field.condition_value &&
                        ([
                          'deaccession_date',
                          'comment_on_deaccession',
                          'new_ownership',
                          'deaccession_price_offer',
                          'deaccession_price_paid',
                          'invoice_deaccession_papers',
                        ].includes(field.name)
                          ? artworkFormData.deaccessioned === 1
                          : field.name === 'fvs_subtitle'
                          ? artworkFormData.type_of_work_id === 7 ||
                            (artworkFormData.type_of_work_id === 6 &&
                              artworkFormData.including_film === 1)
                          : true)
                      "
                      :artwork="artworkFormData"
                      :field="field"
                      :key="field.name"
                      :film="film"
                      @show="show"
                      @showSnackbar="showSnackbar"
                      @getArtwork="getArtwork"
                    ></edit-field>
                    <!-- + (field.dynamic ? ' grey lighten-5' : '') -->
                    <!-- </v-flex> -->

                    <!-- <v-flex xs6 v-else> -->
                    <!-- v-show="df2.indexOf(field['name'])==-1"  -->
                    <read-field
                      v-if="c_user && (!c_user.edit || c_user.edit != 1)"
                      :id="field.name"
                      :name="field.name"
                      :class="'flex ' + (field.class ? field.class : 'xs12')"
                      :artwork="artworkFormData"
                      :field="field"
                      :key="field.name"
                      :film="film"
                    ></read-field>
                  </v-flex>
                </v-layout>
                <!-- </v-flex> -->
              </v-flex>
              <!-- </v-layout>
              </v-container>-->

              <v-flex
                sm12
                md6
                order-sm1
                order-md2
                pl-0
                pr-0
                mt-0
                mb-2
                :class="{ 'pl-4': $vuetify.breakpoint.mdAndUp }"
              >
                <!-- <v-container grid-list-xs fluid pt-0 >
                <v-layout row wrap>-->
                <v-flex
                  elevation-0
                  xs12
                  ml-0
                  style="
                    z-index: 1;
                    top: 270px;
                    position: sticky;
                    background-color: white;
                  "
                >
                  <!-- border-bottom: 1px solid #999; background-color: #fff;  -->
                  <!-- <v-flex xs12 class="pr-0 mt-0"> -->
                  <!-- height="700" -->
                  <!-- <v-carousel height="auto"
                      class="mx-auto img white"
                      v-if="!!processedArtwork.artwork_photos"
                      :hide-delimiters="processedArtwork.artwork_photos.length < 2"
                      :hide-controls="processedArtwork.artwork_photos.length < 2"
                  >-->
                  <!-- :src="`http://www.tb-cms.org/data/artwork/${processedArtwork.id}/${item.id}_th_big.jpg`" -->
                  <!-- v-for="(item,i) in processedArtwork.artwork_photos"
                  :key="i"-->

                  <v-flex
                    class="mx-auto img white text-xs-center pt-2"
                    v-if="
                      artworkFormData.top_photo_id &&
                      artworkFormData.top_photo_id > 0
                    "
                  >
                    <!-- <center> -->
                    <img
                      v-if="artworkFormData.top_photo_id > 0"
                      style="max-width: 100%; background-size: contain;"
                      :src="topPhotoUrl"
                    />
                    <!-- <img
                        v-else-if="
                          [12, 15, 16].includes(artworkFormData.ownership)
                        "
                        style="max-width: 100%;background-size: contain;"
                        :src="
                          `http://www.tb-cms.org/data/artwork/gemini/${artworkFormData.accession_number}.jpg`
                        "
                      /> -->
                    <!-- </center> -->
                    <!-- </v-carousel-item>
                    </v-carousel>-->
                  </v-flex>

                  <v-flex v-else class="text-xs-center my-5 py-5">
                    <div>No Image available</div>
                    <v-btn
                      small
                      round
                      @click="openTopImageFileDialog"
                      :disabled="topImageUploading"
                      color="black"
                      text--color
                      class="white--text mt-4 px-3 xs12"
                    >
                      <v-icon small color="white" class="mr-2"
                        >cloud_upload</v-icon
                      >
                      <span v-if="!topImageUploading">Upload New</span>
                      <span v-else>Uploading {{ topImageUploadProgress }}%</span>
                    </v-btn>
                    <input
                      ref="topImageUploadInput"
                      type="file"
                      accept="image/*"
                      @change="onTopImageFileChange"
                      style="display:none"
                    />
                    <div v-if="topImageUploadMessage" class="subtitle-2 mt-2">
                      {{ topImageUploadMessage }}
                    </div>
                  </v-flex>
                </v-flex>

                <!-- <component v-for="(field, index) in tab.fields[processedArtwork.classification]"
                      :class="'flex d-flex ' + field.class"
                      :key="index"
                      :is='EditField'
                      :value="artworkFormData[field.name]"
                      :field="field"
                      :artwork="artworkFormData"
                      @input="updateForm(field.name, $event.value)"
                      >
                </component>-->
                <!-- <v-btn :disabled="!valid" @click="submit" > submit </v-btn>
                <v-btn @click="clear">clear</v-btn>-->
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </div>
    </v-flex>
    <!-- </v-form> -->
  </div>
</template>

<script>
// import ArtworkForm from './ArtworkForm'
import MultiArtist from '@/components/artworks/MultiArtist.vue'
// import FieldBox from './FieldBox'
import Images from './Images'
import OwnershipHistory from './OwnershipHistory'
import ExhibitionHistory from './ExhibitionHistory'
import LoanHistory from './LoanHistory'
import CustomsHistory from './CustomsHistory'
import axios from '@/utils/apiClient'
import { artworkImageUrl } from '@/utils/artworkMedia'
// import { mapState } from 'vuex'
import Packings from './Packings'
import Selections from './Selections'
import Journals from './Journals'
import Upload from './Upload'
import Conservation from './Conservation'
import ArtworkPublic from './ArtworkPublic'
import Todos from './Todos'
import Tags from './Tags'
import Texts from './Texts'
import Films from './Films'
import Electrical from './Electrical'
import NonElectrical from './NonElectrical'
import ReadingDevices from './ReadingDevices'
import Links from './Links'
import Timeline from './Timeline'
import fields from '@/data/full_user_fields'
import EditField from './EditField'
import ReadField from './ReadField'
// import ViewField from './ViewField'
import PdfEh from './PdfEh'
// import * as qs from 'querystring'

export default {
  props: ['artwork'],
  data() {
    return {
      // gemini_check: "",
      snackbar: false,
      snackbarFieldName: '',
      snackbarColor: 'black',
      timeout: 4000,
      currentFields: [],
      selected: [],
      options: false,
      df2: [],
      fields: fields,
      artworkFormData: Object.assign({}, this.artwork),
      editArtwork: false,
      // artwork: '',
      // result: "",
      currentTab: '',
      valid: true,
      topImageUploading: false,
      topImageUploadProgress: 0,
      topImageUploadMessage: '',
      film: {
        status: '',
        film_type: '',
        duration_min: '',
        duration_timecode: '',
        title: '',
        definition: '',
        color: '',
        sound: '',
        loop: '',
        language: '',
        subtitles: '',
        norm: '',
        aspect_ratio: '',
        fps: '',
        scan_type: '',
        vbr: '',
        file_size: '',
        audio: '',
        date_of_creation: '',
        film_controlling_master: '',
        film_controlling_archive_submaster: '',
        operator: '',
        controlling_date: '',
        controlling_software_2: '',
        controlling_software_1: '',
        operating_system: '',
        controlling_computer_2: '',
        controlling_computer_1: '',
        controling_device: '',
        format_migration_story: '',
        creation_date: '',
      },
    }
  },
  beforeMount() {
    // console.log('----------------')
    // console.log(this.artwork)
    // console.log(this.$route.params.artwork);
    // console.log(this.$route.params.id);
    // this.gemini_check = this.artworkFormData.gemini_check;
    this.getArtwork()
    // console.log("----------------");
    if (!this.artwork) {
      // console.log('!this.artwork')
      if (this.$route.params.artwork) {
        // console.log('this.$route.params.artwork')
        this.artworkFormData = this.$route.params.artwork
      } else {
        // console.log('ELSE this.$route.params.artwork')
        var result = this.$store.state.artworks.find(
          (a) => a.id === this.$route.params.id
        )
        this.artworkFormData = Object.assign({}, result)
      }
    } else {
      // console.log('ELSE !this.artwork')
      this.artworkFormData = Object.assign({}, this.artwork)
      // console.log(this.artworkFormData)
      // this.artwork = Object.assign({}, this.artwork);
      if (
        this.artwork.type_of_work_id === 0 ||
        this.artwork.type_of_work_id == null
      ) {
        // console.log('no type_of_work_id')
        this.setCurrentTab('basic')
        // this.currentTab = "basic";
      } else {
        if (
          this.$store.state.currentTab &&
          this.c_user.roles &&
          this.c_user.roles.find(
            (f) => f.shortcut === this.$store.state.currentTab
          )
        ) {
          // console.log('before mount')
          // console.log(this.$store.state.currentTab.replace("tab-", ""));
          // console.log("before mount");
          this.setCurrentTab(this.$store.state.currentTab.replace('tab-', ''))
        } else {
          // console.log("before mount - ELSE@");
          this.setCurrentTab('basic')
          // this.currentTab = "basic";
        }
      }
    }
  },
  // beforeMount () {
  //   this.getArtwork()
  //   if (this.$route.params.artwork) {
  //     this.result = Object.assign({},this.$route.params.artwork)
  //   } else {
  //     this.result = this.$store.state.artworks.find(a => a.id == this.$route.params.id)
  //     this.artworkFormData = Object.assign({},this.$route.params.artwork)
  //     console.log('store')
  //   }
  //   this.artworkFormData = this.result
  //   this.setCurrentTab('basic')
  // },
  methods: {
    hasArtworkSeries(artwork) {
      return artwork && Array.isArray(artwork.artwork_series) && artwork.artwork_series.length > 0
    },
    artworkSeriesLabel(artwork) {
      if (!this.hasArtworkSeries(artwork)) return ''
      const names = artwork.artwork_series
        .map(series => series.title || series.title_en || series.title_es || 'Untitled series')
        .join(', ')
      return `Part of artwork series: ${names}`
    },
    hasCurrentExhibitions(artwork) {
      return artwork && Array.isArray(artwork.current_exhibitions) && artwork.current_exhibitions.length > 0
    },
    currentExhibitionsLabel(artwork) {
      if (!this.hasCurrentExhibitions(artwork)) return ''
      const names = artwork.current_exhibitions
        .map(exhibition => exhibition.title || exhibition.name || 'Untitled exhibition')
        .join(', ')
      return `Currently on view: ${names}`
    },
    // toggleGemini(value_to_save) {
    //   // this.$emit("showSnackbar", "Saving Gemini check … ");
    //   // setTimeout(() => {
    //   let url = `${this.$globals.apiserver}/artworks/${this.artwork.id}.json`;
    //   axios
    //     .put(url, {
    //       field_name: "gemini_check",
    //       field_value: value_to_save,
    //       updated_by: this.c_user.id
    //     })
    //     .then(response => {
    //       // this.$emit("showSnackbar", "Gemini Check Saved.", "green");
    //       // this.progress = false;
    //       // this.isEditing = false;
    //       // this.$emit("getArtwork");
    //       this.getArtwork();
    //     })
    //     .catch(error => {
    //       this.$emit(
    //         "showSnackbar",
    //         "Error Saving  " + this.f_field.name,
    //         "red"
    //       );
    //       this.progress = false;
    //       this.isEditing = false;
    //     });
    //   // }, 1000);
    // },
    downloadEH(a) {},
    showSnackbar(f, c) {
      // console.log("showSnackbar");
      // console.log(f);
      // console.log(c);
      this.snackbar = true
      this.snackbarFieldName = f
      if (c) {
        this.snackbarColor = c
      }
      setTimeout(() => {
        this.snackbarColor = 'black'
      }, 5000)
    },
    show(f) {
      if (this.df2.length === 0) {
        this.df2 = Object.assign([], this.df)
      }
      // console.log(f)
      var i = this.df2.indexOf(f)
      // console.log(this.df2)
      this.df2.splice(i, 1)
      // console.log(i)
    },
    addToSelection(a) {
      // console.log('a = ' + a)
      // setTimeout(function () {
      var tempSelection = Object.assign([], this.$store.state.currentSelection)
      // console.log(tempSelection)
      // if (!a) {
      // console.log('a true')
      if (!tempSelection.includes(a)) {
        // console.log('doesnt include')
        tempSelection.push(a)
      }
      // } else {
      // console.log('false')
      // var index = tempSelection.indexOf(a);
      // console.log('index = ' + index)
      // tempSelection.splice(index,1)
      // }
      // this.$store.state.currentSelection
      // console.log(tempSelection)
      // this.selected.forEach(s => {
      //   if (!tempSelection.includes(s)) {
      //     tempSelection.push(s)
      //   }
      // })
      // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
      this.$store.dispatch('saveCurrentSelection', tempSelection)
      // }.bind(this),1000)
    },
    verify_accession_no() {
      return false
    },
    openTopImageFileDialog() {
      if (this.$refs.topImageUploadInput) {
        this.$refs.topImageUploadInput.click()
      }
    },
    onTopImageFileChange(event) {
      const file = event.target.files && event.target.files[0]
      if (!file) {
        return
      }
      this.uploadTopImage(file)
      event.target.value = null
    },
    uploadTopImage(file) {
      if (!this.artworkFormData || !this.artworkFormData.id) {
        this.topImageUploadMessage = 'Unable to upload image: missing artwork ID.'
        return
      }

      const formData = new FormData()
      formData.append('files[]', file)
      formData.append('u', this.c_user && this.c_user.id ? this.c_user.id : '')
      formData.append('top', 1)

      this.topImageUploading = true
      this.topImageUploadProgress = 0
      this.topImageUploadMessage = ''

      axios
        .post(
          `${this.$globals.apiserver}/artworks/multi_uploaded_photo_new/${this.artworkFormData.id}`,
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (progressEvent) => {
              if (progressEvent.lengthComputable) {
                this.topImageUploadProgress = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                )
              }
            },
          }
        )
        .then(() => {
          this.topImageUploadMessage = 'Image uploaded successfully.'
          this.showSnackbar('Image uploaded successfully.', 'green')
          this.getArtwork()
        })
        .catch((error) => {
          console.error('Top image upload failed', error)
          this.topImageUploadMessage = 'Image upload failed. Please try again.'
          this.showSnackbar('Image upload failed. Please try again.', 'red')
        })
        .finally(() => {
          this.topImageUploading = false
          this.topImageUploadProgress = 0
        })
    },
    setCurrentTab (tab, closeOptions = true) {
      // console.log(tab)
      // console.log(this.fields.tabs['basic'])
      // console.log(this.field_list)
      if (this.fields.tabs[tab].fields) {
        var fields = this.fields.tabs[tab].fields
        // console.log(fields)
        // console.log(this.artwork['classification'])

        // fields = fields.filter(f => f.edit_only === true)
        fields = fields.filter((f) =>
          f.work_types_new.some(
            (wt) => wt === this.artworkFormData['type_of_work_id']
          )
        )
        this.currentFields = fields
      }

      if (!this.currentFields) {
        this.currentFields = this.fields.tabs[tab]
      }
      // console.log("tab.substring");
      // console.log(tab.replace("tab-", ""));
      this.currentTab = tab
      this.saveCurrentTab(tab)
      if (closeOptions) this.options_c = false
    },
    saveCurrentTab(tab) {
      // setTimeout(function () {
      this.$store.dispatch('saveCurrentTab', tab)
      // }.bind(this),1000)
    },
    getArtwork() {
      let url = `${this.$globals.apiserver}/artworks/${this.$route.params.id}.json`
      axios
        .get(url)
        .then((response) => {
          // this.result = response.data;
          // console.log('loading artwork')
          this.artworkFormData = response.data
          // this.artwork = response.data
          // console.log(this.artworkFormData)
          this.df2 = this.df()
          // this.$store.dispatch("replaceArtwork", response.data);
          // if (this.$route.params.artwork) {
          //   this.result = this.$route.params.artwork;
          // } else {
          //   this.result = this.$store.state.artworks.find(
          //     a => a.id == this.$route.params.id
          //   );
          //   this.artworkFormData = this.result;
          // }
          if (
            this.artworkFormData.type_of_work_id === 0 ||
            this.artworkFormData.type_of_work_id == null
          ) {
            this.currentTab = 'basic'
          } else {
            if (this.$store.state.currentTab) {
              this.setCurrentTab(
                this.$store.state.currentTab.replace('tab-', ''),
                false
              )
            } else {
              this.currentTab = 'basic'
            }
          }
        })
        .catch((error) => {
          this.artworkFormData = {
            id: this.$route.params.id,
            title: 'Artwork not found',
            type_of_work_id: 2,
          }
          // console.log(error)
        })
      // if(this.$store.state.currentTab) {
      //   console.log('before mount')
      //   console.log(this.$store.state.currentTab.replace('tab-',''))
      //   this.setCurrentTab(this.$store.state.currentTab);
      // } else {
      //   this.setCurrentTab("basic");
      // }
    },
    clear() {
      this.$refs.form.reset()
    },
    // submit() {
    //   const art = this.artworkFormData;
    //   const requestConfig = {
    //     url: `http://www.tb-cms.org/artworks/api_update/${this.$route.params.id}`,
    //     method: "POST",
    //     data: qs.stringify(art)
    //   };
    //   const response = axios.request(requestConfig);
    // },
    df() {
      // var c = []
      // var b = []
      var x = []
      var fields2 = []
      fields2 = fields2.concat(fields['tabs']['basic']['fields'])
      // console.log(fields2)
      fields2 = fields2.concat(fields['tabs']['advanced']['fields'])
      // console.log(fields2)
      fields2 = fields2.concat(fields['tabs']['acquisition']['fields'])
      // console.log(fields2)
      // console.log('fields2')
      // var fields2 = Object.values(fields['tabs'][this.$store.state.currentTab.substr(4)]['fields'][this.f_artwork.classification])
      // console.log('test')
      // if (fields2.length > 0) {
      // var class_fields = fields2[this.f_artwork.classification]
      // c = fields2.filter(f => (f.dynamic && f.work_types && f.work_types.includes(this.artworkFormData.classification)))
      // console.log(c.length)
      // b = c.filter(f => (this.artworkFormData[f.name] == null || this.artworkFormData[f.name] == undefined || this.artworkFormData[f.name] == '') )
      // console.log(b.length)
      // b = b.map(f => f.name)
      // console.log(c)
      // console.log(b)
      // setTimeout(function () {
      // console.log(fields2)
      // console.log(this.artworkFormData.classification)
      for (var f in fields2) {
        // console.log(fields2[f].name)
        // console.log(fields2[f].dynamic)
        // console.log(this.artworkFormData[fields2[f].name])
        if (
          fields2[f].dynamic &&
          fields2[f].work_types_new &&
          fields2[f].work_types_new.includes(
            this.artworkFormData.type_of_work_id
          ) &&
          (this.artworkFormData[fields2[f].name] == null ||
            this.artworkFormData[fields2[f].name] === undefined ||
            this.artworkFormData[fields2[f].name] === '')
        ) {
          // console.log(fields2[f])
          x.push(fields2[f].name)
        }
      }
      // }.bind(this),4000)
      // console.log(x)
      // console.log(this.artworkFormData.classification)
      // c = c.filter(f => (f.work_types && f.work_types.includes(this.artwork.classification)))
      // console.log(c)
      // }
      // console.log(fields['tabs'][this.$store.state.currentTab.substr(4)]['fields'][this.f_artwork.classification].filter(f => f.dynamic))
      return x
    },
    goToNextTab() {
      if (this.hasNextTab) {
        var ct = this.user_tabs.find((t) => t.key === this.currentTab)
        // console.log('ct')
        if (ct) {
          // console.log(this.user_tabs.indexOf(ct))
          this.setCurrentTab(this.user_tabs[this.user_tabs.indexOf(ct) + 1].key)
        } else {
          return null
        }
        // this.saveCurrentTab(this.user_tabs[this.user_tabs.indexOf(ct) + 1].key);
      } else {
        return null
      }
    },
    goToPreviousTab() {
      if (this.hasPreviousTab) {
        var ct = this.user_tabs.find((t) => t.key === this.currentTab)
        // console.log('ct')
        if (ct) {
          // console.log(this.user_tabs.indexOf(ct))
          this.setCurrentTab(this.user_tabs[this.user_tabs.indexOf(ct) - 1].key)
        } else {
          return null
        }
        // this.saveCurrentTab(this.user_tabs[this.user_tabs.indexOf(ct) - 1].key);
        // this.setCurrentTab(this.user_tabs[this.user_tabs.indexOf(this.currentTab) - 1].key);
      } else {
        return null
      }
    },
  },
  computed: {
    topPhotoUrl() {
      return artworkImageUrl(
        this.artworkFormData,
        ['cms_big', 'cms_middle', 'cms_thumbnail'],
        this.$globals.apiserver,
        this.$globals.fileserver
      )
    },
    // lists all enabled field names - good for checking if fields exists in database
    // all_field_names() {
    //   var o = [];
    //   for (var t in this.fields["tabs"]) {
    //     console.log(t)
    //     for (var f in this.fields["tabs"][t]["fields"]) {
    //       console.log(f)
    //       if (!this.fields["tabs"][t]["fields"][f].component && !this.fields["tabs"][t]["fields"][f].headline && !this.fields["tabs"][t]["fields"][f].subheadline) {
    //         o.push(this.fields["tabs"][t]["fields"][f].name)
    //       }
    //     }
    //   }
    //   return o
    // },
    hasNextTab() {
      var ct = this.user_tabs.find((t) => t.key === this.currentTab)
      return this.user_tabs.length > this.user_tabs.indexOf(ct) + 1
    },
    hasPreviousTab() {
      var ct = this.user_tabs.find((t) => t.key === this.currentTab)
      return this.user_tabs.indexOf(ct) !== 0
    },
    user_tabs() {
      let newf = []
      // console.log('user_tabs')
      // console.log(this.c_user.roles)
      // console.log(this.fields.tabs["basic"]);
      // // console.log(tab.work_types)
      // console.log(this.artworkFormData.classification)
      // console.log('test1')
      var ar
      if (this.artwork) {
        // console.log('///////////this.artwork')
        ar = this.artwork
      } else {
        // console.log('no this.artwork')
        if (this.$route.params.artwork) {
          // console.log('this.$route.params.artwork')
          ar = this.$route.params.artwork
        } else {
          // console.log('NO this.$route.params.artwork')
          ar = this.$store.state.artworks.find(
            (a) => a.id === this.$route.params.id
          )
          // this.artworkFormData = this.result;
        }
      }
      if (!ar) {
        ar = this.artworkFormData
      }
      // console.log('----------------2');
      // console.log(this.artwork);
      // console.log(this.$route.params.artwork);
      // console.log(this.$route.params.id);
      // console.log(ar)
      // console.log('----------------2');
      if (ar) {
        if (ar.type_of_work_id === 0 || ar.type_of_work_id == null) {
          return [this.fields.tabs['basic'], this.fields.tabs['public']]
        } else {
          for (var tab in this.fields.tabs) {
            if (this.fields.tabs[tab].key === 'public') continue
            if (
              this.c_user.roles &&
              this.c_user.roles.find(
                (f) => f.shortcut === this.fields.tabs[tab].role
              ) &&
              this.fields.tabs[tab].work_types_new &&
              this.fields.tabs[tab].work_types_new.includes(ar.type_of_work_id)
            ) {
              newf.push(this.fields.tabs[tab])
            }
          }
          const publicTab = this.fields.tabs['public']
          if (
            this.c_user.roles &&
            this.c_user.roles.find((role) => role.shortcut === publicTab.role)
          ) {
            newf.push(publicTab)
          }
        }
      }
      return newf
    },
    // c_user() {
    //   return this.$store.state.user.profile;
    // },
    options_c: {
      get() {
        return this.$store.state.options
      },
      set(value) {
        this.$store.dispatch('saveOptions', value)
      },
    },
    currentTabShown() {
      // console.log('currentTabShown')
      // console.log(this.currentTab)
      // console.log(fields.tabs[this.currentTab])
      return fields.tabs[this.currentTab]
    },
    df3() {
      // var c = []
      var b = []
      var x = []
      var fields2 = []
      fields2 = fields2.concat(fields['tabs']['basic']['fields'])
      // console.log(fields2)
      fields2 = fields2.concat(fields['tabs']['advanced']['fields'])
      // console.log(fields2)
      fields2 = fields2.concat(fields['tabs']['acquisition']['fields'])
      // console.log(fields2)
      // console.log('fields2')
      // var fields2 = Object.values(fields['tabs'][this.$store.state.currentTab.substr(4)]['fields'][this.f_artwork.classification])
      // console.log('test')
      // if (fields2.length > 0) {
      // var class_fields = fields2[this.f_artwork.classification]
      // c = fields2.filter(f => (f.dynamic && f.work_types && f.work_types.includes(this.artworkFormData.classification)))
      // console.log(c.length)
      // b = c.filter(f => (this.artworkFormData[f.name] == null || this.artworkFormData[f.name] == undefined || this.artworkFormData[f.name] == '') )
      // console.log(b.length)
      // b = b.map(f => f.name)
      // console.log(c)
      // console.log(b)
      // setTimeout(function () {
      // console.log(fields2)
      for (var f in fields2) {
        // console.log(fields2[f].name)
        // console.log(this.artworkFormData[fields2[f].name])
        if (
          fields2[f].dynamic &&
          f.work_types_new &&
          fields2[f].work_types_new.includes(
            this.artworkFormData.type_of_work_id
          ) &&
          (this.artworkFormData[fields2[f].name] == null ||
            this.artworkFormData[fields2[f].name] === undefined ||
            this.artworkFormData[fields2[f].name] === '')
        ) {
          // console.log(fields2[f])
          x.push(f.name)
        }
      }
      // }.bind(this),4000)
      // console.log(x)
      // console.log(this.artworkFormData.classification)
      // c = c.filter(f => (f.work_types && f.work_types.includes(this.artwork.classification)))
      // console.log(c)
      // }
      // console.log(fields['tabs'][this.$store.state.currentTab.substr(4)]['fields'][this.f_artwork.classification].filter(f => f.dynamic))
      return b
    },
    field_list() {
      // console.log(this.fields['tabs'].find(t => t.key == this.currentTab))
      // return this.fields['tabs'].find(t => t.key == this.currentTab)
      if (!this.fields['tabs'][this.currentTab.substr(4)].component) {
        // var current_user = { role: 'admin' }
        // var work_type = 'pppd'
        var out = []
        var fields2 = fields['tabs'][this.currentTab.substr(4)]['fields']
        out = fields2.filter(
          (f, i) =>
            f.work_types_new &&
            f.work_types_new.includes(this.artworkFormData.type_of_work_id)
        )
        return out
      } else {
        return []
      }
    },
    // processedArtwork() {
    //   var artwork = this.artworkFormData;
    //   if (artwork && artwork.artwork_photos) {
    //     artwork.keywords = [];
    //     for (var ap in artwork.artwork_photos) {
    //       if (artwork.artwork_photos[ap].keywords) {
    //         try {
    //           artwork.artwork_photos[ap].keywords = JSON.parse(
    //             artwork.artwork_photos[ap].keywords
    //           ).map((k) => (k = k.toString()));
    //         } catch (err) {
    //           // console.log('error while parsing keywords')
    //         }
    //       } else {
    //         artwork.artwork_photos[ap].keywords = [];
    //       }
    //       artwork.keywords = artwork.keywords.concat(
    //         artwork.artwork_photos[ap].keywords.map((k) => (k = k.toString()))
    //       );
    //     }
    //   }
    //   if (artwork && artwork.keywords) {
    //     artwork.keywords = [...new Set(artwork.keywords)];
    //     artwork.keywords = artwork.keywords.sort(function (a, b) {
    //       return a.toUpperCase().localeCompare(b.toUpperCase());
    //     });
    //   }
    //   // console.log('artwork')
    //   // console.log(artwork)
    //   return artwork;
    // },
  },
  components: {
    Timeline,
    ReadField,
    EditField,
    Images,
    ExhibitionHistory,
    CustomsHistory,
    LoanHistory,
    MultiArtist,
    Packings,
    Selections,
    Journals,
    Upload,
    Todos,
    Tags,
    Texts,
    Films,
    Electrical,
    ReadingDevices,
    OwnershipHistory,
    Links,
    NonElectrical,
    PdfEh,
    Conservation,
    ArtworkPublic,
  },
}
</script>

// text-decoration: underline;
<style scoped>
a.tabswitcher span {
  padding: 8px;
  margin-left: 3px;
}
a:hover.tabswitcher span {
  background-color: rgb(218, 218, 218);
  color: rgb(0, 0, 0);
}
small {
  font-size: 16px;
}
.series-indicator {
  color: #555;
  vertical-align: text-bottom;
}
.on-view-indicator {
  color: #2e7d32;
  vertical-align: text-bottom;
}
h4 a:hover {
  text-decoration: underline;
}
.v-list__group__items--no-action .v-list__tile.activeMenu {
  padding-left: 25px;
}
.activeMenu {
  border: white 1px solid;
  margin: 0px 0px 3px 4px;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/artworks/EditArtwork.vue